import { render, staticRenderFns } from "./BookNicheIcon.vue?vue&type=template&id=0308d88e&scoped=true"
import script from "./BookNicheIcon.vue?vue&type=script&lang=js"
export * from "./BookNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308d88e",
  null
  
)

export default component.exports